export class ProductRestrictionOrganisationCommandModel {
    public productRestrictionOrganisationId: string;
    public organisationId: string;
    public organisationTypeCode: string;
    public organisationRoleCode: string;
    public organisationGroupCode: string;
    public excludeFlag: boolean;
    public displaySequence: number;
    public productRestrictionOrganisationTypeCode: string;
}